import {
  SeuApiCanvasComponent,
  SeuApiCanvasStream,
  SeuApiInterconnectionCanvas,
} from '../api';

// Grid configuration for 2D canvas
export const SEU_CANVAS_GRID_CELL_SIZE = 288;
export const SEU_CANVAS_BUFFER_CELLS = 2;
// Also adjust width in canvas-component.scss if this value is changed (12.25rem)
export const SEU_CANVAS_COMPONENT_DRAG_PREVIEW_WIDTH = 196;

export const SEU_CANVAS_INITIAL_INPUT_STREAM_POS_Y = 0;
export const SEU_CANVAS_INITIAL_INPUT_STREAM_POS_X = 0;

// Global ID for chimney
export const SEU_CHIMNEY_COMPONENT_ID = '-1';

// Component type for chimney
export const SEU_CHIMNEY_COMPONENT_TYPE = 'chimney';

// Component type for input stream
export const SEU_INPUT_STREAM_COMPONENT_TYPE = 'input-stream';

// Component types with special canvas styling (square, dark-blue card variant)
// Add new types here — the rest of the rendering logic picks this up automatically
export const SEU_MIXER_COMPONENT_TYPE = 'Mixer';
export const SEU_SPLITTER_COMPONENT_TYPE = 'Splitter';
export const SEU_SQUARE_VARIANT_COMPONENT_TYPES = new Set([
  SEU_MIXER_COMPONENT_TYPE,
  SEU_SPLITTER_COMPONENT_TYPE,
]);

export type SeuCoords = {
  x: number;
  y: number;
};

export type SeuCanvasListType = 'interconnection' | 'stack';

export type SeuCanvasViewMode = 'edit' | 'present' | 'results';

export type SeuCanvasMouseTool = 'pointer' | 'hand';

export type SeuCanvasResultsToolBox = 'layerview' | 'crosshairs';

export type SeuCanvasResultsTool = 'capexOpex' | 'additives' | 'crosshairs';

export type SeuCanvasStreamStart = {
  connectionPoint: 'input' | 'output';
  index: number;
} & SeuCoords;

export type SeuCanvasRemoveComponentEvent = {
  componentId: string;
};

export type SeuCanvasInputOutputClickEvent = {
  event: MouseEvent;
  handleIndex?: number;
};

export type SeuCanvasInputStream = SeuCanvasComponentCoords & {
  inputStreamId: string;
};

export type SeuCanvasComponentCoords = {
  posX: number;
  posY: number;
};

export type SeuCanvasElement = SeuCanvasComponentCoords & {
  id?: string;
};

export type SeuCanvas = {
  canvasStreams: SeuCanvasStream[];
  components: SeuCanvasComponent[];
  inputStreams: SeuCanvasInputStream[];
  chimney?: SeuCanvasElement;
};

export type SeuCanvasStream = {
  canvasStreamId?: string;
  name?: string;
  linkedToChimney?: boolean;
  inputStreamId?: string;
  outputFromComponentId?: string;
  outputFromComponentHandleId?: string;
  inputForComponentId?: string;
  inputForComponentHandleId?: string;
};

export type SeuCanvasStreamPositionItem = SeuCanvasStream & {
  startX: number;
  startY: number;
  endX: number;
  endY: number;
};

export type SeuCanvasComponent = SeuCanvasComponentCoords & {
  componentId: string;
};

export type SeuCanvasInputStreamApi = SeuCanvasComponentCoords & {
  inputStreamId: string;
};

export type SeuCanvasApi = SeuApiInterconnectionCanvas;

export type SeuCanvasStreamApi = SeuApiCanvasStream;

export type SeuCanvasComponentApi = SeuApiCanvasComponent;

export type SeuCanvasLocationStorageItem = {
  offsetX: number;
  offsetY: number;
  startX: number;
  startY: number;
};
